<!-- FormWrapper.vue -->
<template>
  <div>
    <!-- <iframe ref="iframe" width="100%" height="600px"></iframe> -->

    <v-form-component
      :hasParent="shipment_id != 0"
      :model="computedCurrentModel"
      :parentModel="shipmentObject ? shipmentObject.model : null"
      :schema="currentSchema"
      :data_object="shipmentObject"
      :onValueChange="onValueChange"
      class="mb-2 mt-n2 pa-0"
      :compclass="'mb-n4 mt-n2 pa-0'"
      :key="formKey"
      :mainTab="mainTab"
      :noMainTabs="false"
      :changeTab="changeTab"
      :toolBarControls="toolBarControls"
    ></v-form-component>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import store from "./../store";

const vuetifyInstance = new Vuetify();
Vue.use(Vuetify);
export default {
  props: {
    computedCurrentModel: Object,
    shipmentObject: Object,
    onValueChange: Function,
    toolBarControls: Array,
    mainTab: Object,
    changeTab: Function,
    currentSchema: Object,
    formKey: Number,
  },
  data: () => ({
    shipment_id: "",
  }),
  mounted() {
    console.log("mounted");
    // this.loadIframeContent();
    this.shipment_id = this.$route.params.id;
  },
  components: {
    VFormComponent: () => import("../components/FormComponent.vue"),
  },
  methods: {
    // loadIframeContent() {
    //   const iframe = this.$refs.iframe;
    //   const doc = iframe.contentDocument || iframe.contentWindow.document;
    //   doc.open();
    //   doc.write('<div id="app"></div>');
    //   doc.close();
    //   // Create a new Vue instance in the iframe and pass the necessary props
    //   new Vue({
    //     vuetify: vuetifyInstance,
    //     store,
    //     render: (h) =>
    //       h(VFormComponent, {
    //         props: {
    //           hasParent: this.hasParent,
    //           modelReady: true,
    //           model: this.computedCurrentModel,
    //           parentModel: this.shipmentObject
    //             ? this.shipmentObject.model
    //             : null,
    //           schema: this.currentSchema,
    //           data_object: this.shipmentObject,
    //           onValueChange: this.onValueChange,
    //           class: "mb-2 mt-n2 pa-0",
    //           compclass: "mb-n4 mt-n2 pa-0",
    //           key: this.formKey,
    //           mainTab: this.mainTab,
    //           noMainTabs: false,
    //           changeTab: this.changeTab,
    //           toolBarControls: this.toolBarControls,
    //         },
    //       }),
    //   }).$mount(doc.getElementById("app"));
    // },
  },
};
</script>
